import React, { useState } from 'react';

const CreditPanel = ({ isOpen, onClose, currentCredits = 0, otjUser, onCreditAdded }) => {
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  // 크레딧 추가 방법들
  const creditMethods = [
    {
      id: 'payment',
      title: '크레딧 구매',
      icon: 'credit_card',
      color: 'blue',
      description: '안전한 결제로 즉시 크레딧을 충전하세요',
      options: [
        { amount: 10000, price: '₩5,000', bonus: 0, popular: false },
        { amount: 25000, price: '₩10,000', bonus: 5000, popular: true },
        { amount: 60000, price: '₩20,000', bonus: 15000, popular: false },
        { amount: 150000, price: '₩40,000', bonus: 50000, popular: false }
      ]
    },
    {
      id: 'invite',
      title: '친구 초대',
      icon: 'person_add',
      color: 'green',
      description: '친구를 초대하고 둘 다 크레딧을 받으세요',
      reward: '친구 1명당 3,000 크레딧',
      action: '초대 링크 복사'
    },
    {
      id: 'ads',
      title: '광고 시청',
      icon: 'play_circle',
      color: 'purple',
      description: '짧은 광고를 시청하고 크레딧을 받으세요',
      reward: '광고 1개당 500 크레딧',
      dailyLimit: '하루 최대 10회 (5,000 크레딧)',
      action: '광고 시청하기'
    },
    {
      id: 'survey',
      title: '설문조사',
      icon: 'quiz',
      color: 'orange',
      description: '간단한 설문조사 참여로 크레딧 획득',
      reward: '설문 1개당 1,000 크레딧',
      action: '설문 참여하기'
    },
    {
      id: 'social',
      title: '소셜 미션',
      icon: 'share',
      color: 'pink',
      description: 'SNS 공유하고 크레딧을 받으세요',
      reward: '공유 1회당 800 크레딧',
      action: '공유하기'
    }
  ];

  const handleMethodClick = (method) => {
    setSelectedMethod(selectedMethod?.id === method.id ? null : method);
  };

  const handleAction = async (method, option = null) => {
    setIsProcessing(true);
    
    try {
      // TODO: 실제 API 호출 구현
      switch (method.id) {
        case 'payment':
          if (option) {
            console.log(`결제 시작: ${option.price} - ${option.amount + option.bonus} 크레딧`);
            // 결제 API 호출
            alert(`${option.price} 결제 화면으로 이동합니다.\n받을 크레딧: ${(option.amount + option.bonus).toLocaleString()}`);
            // TODO: 실제 결제 성공 시 onCreditAdded 호출
            // if (결제 성공) {
            //   onCreditAdded?.(option.amount + option.bonus);
            // }
          }
          break;
        case 'invite':
          // 초대 링크 생성 및 복사
          const inviteLink = `https://otalja.com/invite?ref=${otjUser?.primaryKey || 'demo'}`;
          await navigator.clipboard.writeText(inviteLink);
          alert('초대 링크가 클립보드에 복사되었습니다!\n친구에게 공유해보세요.');
          // TODO: 친구가 가입하면 크레딧 추가
          break;
        case 'ads':
          console.log('광고 시청 시작');
          alert('광고 시청 화면으로 이동합니다.');
          // TODO: 광고 시청 완료 시 onCreditAdded(500) 호출
          break;
        case 'survey':
          console.log('설문조사 시작');
          alert('설문조사 페이지로 이동합니다.');
          // TODO: 설문조사 완료 시 onCreditAdded(1000) 호출
          break;
        case 'social':
          console.log('소셜 공유 시작');
          alert('SNS 공유 화면으로 이동합니다.');
          // TODO: 공유 완료 시 onCreditAdded(800) 호출
          break;
        default:
          break;
      }
    } catch (error) {
      console.error('크레딧 추가 오류:', error);
      alert('오류가 발생했습니다. 다시 시도해주세요.');
    } finally {
      setIsProcessing(false);
    }
  };

  const getColorClasses = (color, selected = false) => {
    const colors = {
      blue: selected 
        ? 'bg-blue-50 border-blue-200 text-blue-800' 
        : 'border-gray-200 hover:border-blue-300 hover:bg-blue-50',
      green: selected 
        ? 'bg-green-50 border-green-200 text-green-800' 
        : 'border-gray-200 hover:border-green-300 hover:bg-green-50',
      purple: selected 
        ? 'bg-purple-50 border-purple-200 text-purple-800' 
        : 'border-gray-200 hover:border-purple-300 hover:bg-purple-50',
      orange: selected 
        ? 'bg-orange-50 border-orange-200 text-orange-800' 
        : 'border-gray-200 hover:border-orange-300 hover:bg-orange-50',
      pink: selected 
        ? 'bg-pink-50 border-pink-200 text-pink-800' 
        : 'border-gray-200 hover:border-pink-300 hover:bg-pink-50'
    };
    return colors[color] || colors.blue;
  };

  const getIconColor = (color) => {
    const colors = {
      blue: 'text-blue-600',
      green: 'text-green-600',
      purple: 'text-purple-600',
      orange: 'text-orange-600',
      pink: 'text-pink-600'
    };
    return colors[color] || colors.blue;
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
        {/* 헤더 */}
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 rounded-t-2xl">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center">
                <span className="material-icons text-white text-lg">account_balance_wallet</span>
              </div>
              <div>
                <h2 className="text-xl font-bold text-gray-900">크레딧 추가</h2>
                <p className="text-sm text-gray-600">보유 크레딧: <span className="font-semibold text-blue-600">{currentCredits.toLocaleString()}</span></p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <span className="material-icons text-2xl">close</span>
            </button>
          </div>
        </div>

        {/* 본문 */}
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
            {creditMethods.map((method) => (
              <div
                key={method.id}
                className={`p-4 rounded-xl border-2 cursor-pointer transition-all duration-200 ${getColorClasses(method.color, selectedMethod?.id === method.id)}`}
                onClick={() => handleMethodClick(method)}
              >
                <div className="flex items-start space-x-3">
                  <div className={`w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0`}>
                    <span className={`material-icons text-xl ${getIconColor(method.color)}`}>
                      {method.icon}
                    </span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-semibold text-gray-900 mb-1">{method.title}</h3>
                    <p className="text-sm text-gray-600 mb-2">{method.description}</p>
                    {method.reward && (
                      <div className="text-sm font-medium text-blue-600 mb-1">
                        💎 {method.reward}
                      </div>
                    )}
                    {method.dailyLimit && (
                      <div className="text-xs text-gray-500">
                        {method.dailyLimit}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* 선택된 방법의 상세 정보 */}
          {selectedMethod && (
            <div className="bg-gray-50 rounded-xl p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                <span className={`material-icons mr-2 ${getIconColor(selectedMethod.color)}`}>
                  {selectedMethod.icon}
                </span>
                {selectedMethod.title}
              </h3>

              {selectedMethod.id === 'payment' && selectedMethod.options && (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
                  {selectedMethod.options.map((option, index) => (
                    <div
                      key={index}
                      className={`relative p-4 bg-white rounded-lg border-2 transition-all duration-200 hover:border-blue-300 cursor-pointer ${option.popular ? 'border-blue-400 ring-2 ring-blue-100' : 'border-gray-200'}`}
                      onClick={() => handleAction(selectedMethod, option)}
                    >
                      {option.popular && (
                        <div className="absolute -top-2 left-1/2 transform -translate-x-1/2">
                          <span className="bg-blue-500 text-white text-xs px-2 py-1 rounded-full">인기</span>
                        </div>
                      )}
                      <div className="text-center">
                        <div className="text-lg font-bold text-gray-900">
                          {(option.amount + option.bonus).toLocaleString()}
                        </div>
                        <div className="text-sm text-gray-600 mb-2">크레딧</div>
                        <div className="text-xl font-bold text-blue-600 mb-1">{option.price}</div>
                        {option.bonus > 0 && (
                          <div className="text-xs text-green-600 font-medium">
                            +{option.bonus.toLocaleString()} 보너스
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {selectedMethod.id !== 'payment' && selectedMethod.action && (
                <button
                  onClick={() => handleAction(selectedMethod)}
                  disabled={isProcessing}
                  className={`w-full md:w-auto px-6 py-3 rounded-lg font-medium transition-colors ${
                    isProcessing 
                      ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                      : `bg-${selectedMethod.color}-600 hover:bg-${selectedMethod.color}-700 text-white`
                  }`}
                  style={{
                    backgroundColor: isProcessing ? undefined : 
                      selectedMethod.color === 'blue' ? '#2563eb' :
                      selectedMethod.color === 'green' ? '#16a34a' :
                      selectedMethod.color === 'purple' ? '#9333ea' :
                      selectedMethod.color === 'orange' ? '#ea580c' :
                      selectedMethod.color === 'pink' ? '#db2777' : '#2563eb'
                  }}
                >
                  {isProcessing ? (
                    <div className="flex items-center">
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-current mr-2"></div>
                      처리 중...
                    </div>
                  ) : (
                    <div className="flex items-center">
                      <span className="material-icons mr-2">{selectedMethod.icon}</span>
                      {selectedMethod.action}
                    </div>
                  )}
                </button>
              )}
            </div>
          )}
        </div>

        {/* 푸터 */}
        <div className="border-t border-gray-200 px-6 py-4 bg-gray-50 rounded-b-2xl">
          <div className="flex items-center justify-between text-sm text-gray-600">
            <div className="flex items-center space-x-4">
              <div className="flex items-center">
                <span className="material-icons text-green-600 mr-1">security</span>
                안전한 결제
              </div>
              <div className="flex items-center">
                <span className="material-icons text-blue-600 mr-1">support</span>
                24시간 고객지원
              </div>
            </div>
            <div className="text-xs text-gray-500">
              문의: help@otalja.com
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreditPanel; 